import type {
	PaginatedParams,
	PaginatedQueryOptions,
	Region,
} from '@lqa-frontend/api-services';
import { endpoints, usePaginatedQuery } from '@lqa-frontend/api-services';

/** Regions of a brand — backend requires `brandId`. */
export function useBrandRegionsQuery(
	params: BrandRegionsQueryParams,
	options?: PaginatedQueryOptions<Region>
) {
	return usePaginatedQuery<Region>(
		endpoints.customerRegions.index,
		params,
		options
	);
}

export interface BrandRegionsQueryParams extends PaginatedParams {
	brandId?: number;
	regionName?: string;
}

export function useRegionsQuery(
	params: RegionsQueryParams,
	options?: PaginatedQueryOptions<Region>
) {
	return usePaginatedQuery<Region>(endpoints.regions.index, params, options);
}

export interface RegionsQueryParams extends PaginatedParams {
	regionName?: string;
	brandIds?: number[];
	includedNonCustomRegions?: 'true' | 'false';
	isActive?: boolean;
}
